import {Logic} from './Type'
import * as Assets from '../assets/Assets'
import * as R from '../Socket/route-classes'

export class Fantasy extends Logic.Type {
  name: string
  matchesSet: boolean = false
  location: number = Assets.location.firstPage
  openConfirmation: boolean = false
  roundId: number
  roundPlayed: boolean
  chosenResults: R.IBet
  selectedResult: string[] = ['---', '---', '---', '---', '---', '---', '---', '---', '---' ,'---']
  selectedAcc: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  firstName: string = ''
  lastName: string = ''
  email: string = ''
  username: string = ''
  password: string = ''
  passwordConfirmation: string = ''
  nationality: string
  playerId: number
  mobileMenuTop: boolean
  mobileMenuMid: boolean
  roundMenu: boolean
  leaderboardTypeClicked: number = 0
  leaderboardRoundClicked: number = 0
  resultRoundClicked: number = 0
  leaguesTab: number = 1
  leagueName: string
  leagueKey: string
  leaderboardLeagueName: string
  leaderboardLeagueId: number
  overallRanking: boolean
  showConfirmButton: boolean = true
  competitionTab: number = 1
}



// WEBPACK FOOTER //
// ./src/Logic/Index.ts